import { render, staticRenderFns } from "./finsh.vue?vue&type=template&id=6c7b1bf8&scoped=true"
import script from "./finsh.vue?vue&type=script&lang=js"
export * from "./finsh.vue?vue&type=script&lang=js"
import style0 from "./finsh.vue?vue&type=style&index=0&id=6c7b1bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7b1bf8",
  null
  
)

export default component.exports